// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement_proxy.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { AppEntitlementView } from "./app_entitlement";
import { AppEntitlementExpandMask } from "./app_entitlement";
import { Facets } from "../../search/v1/facet";
import { AncestralBinding } from "./app_entitlement";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.app.v1.GetAppEntitlementProxyRequest
 */
export interface GetAppEntitlementProxyRequest {
    /**
     * @generated from protobuf field: string src_app_id = 1
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4
     */
    dstAppEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementProxyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppEntitlementProxyResponse
 */
export interface GetAppEntitlementProxyResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view = 1
     */
    appProxyEntitlementView?: AppEntitlementProxyView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementProxy
 */
export interface AppEntitlementProxy {
    /**
     * @generated from protobuf field: string src_app_id = 1
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4
     */
    dstAppEntitlementId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool system_builtin = 8
     */
    systemBuiltin: boolean;
    /**
     * If true, the binding doesn't not exist yet and is from the list of the entitlements from the parent app.
     * typically the IdP that handles provisioning for the app instead of C1s connector.
     *
     * @generated from protobuf field: optional bool implicit = 9
     */
    implicit?: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp disabled_at = 10
     */
    disabledAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementProxyView
 */
export interface AppEntitlementProxyView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxy app_proxy_entitlement = 1
     */
    appProxyEntitlement?: AppEntitlementProxy;
    /**
     * @generated from protobuf field: string src_app_path = 2
     */
    srcAppPath: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_path = 3
     */
    srcAppEntitlementPath: string;
    /**
     * @generated from protobuf field: string dst_app_path = 4
     */
    dstAppPath: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_path = 5
     */
    dstAppEntitlementPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementProxyExpandMask
 */
export interface AppEntitlementProxyExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppEntitlementProxyRequest
 */
export interface CreateAppEntitlementProxyRequest {
    /**
     * @generated from protobuf field: string src_app_id = 1
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4
     */
    dstAppEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementProxyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppEntitlementProxyResponse
 */
export interface CreateAppEntitlementProxyResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view = 1
     */
    appProxyEntitlementView?: AppEntitlementProxyView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementProxyRequest
 */
export interface DeleteAppEntitlementProxyRequest {
    /**
     * @generated from protobuf field: string src_app_id = 1
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4
     */
    dstAppEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementProxyWithCreateDestination
 */
export interface AppEntitlementProxyWithCreateDestination {
    /**
     * @generated from protobuf field: string src_app_id = 1
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_resource_name = 4
     */
    dstResourceName: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.BindingWithNewOrExisting
 */
export interface BindingWithNewOrExisting {
    /**
     * @generated from protobuf oneof: binding
     */
    binding: {
        oneofKind: "appProxyEntitlement";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxy app_proxy_entitlement = 1
         */
        appProxyEntitlement: AppEntitlementProxy;
    } | {
        oneofKind: "appProxyEntitlementCreate";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyWithCreateDestination app_proxy_entitlement_create = 2
         */
        appProxyEntitlementCreate: AppEntitlementProxyWithCreateDestination;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsRequest
 */
export interface BulkCreateAppEntitlementProxyWithDestinationsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.BindingWithNewOrExisting bindings = 1
     */
    bindings: BindingWithNewOrExisting[];
}
/**
 * @generated from protobuf message c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsResponse
 */
export interface BulkCreateAppEntitlementProxyWithDestinationsResponse {
    /**
     * Map of app proxy entitlement ID to errors. The format of the id is <src_app_id>:<src_app_entitlement_id>:<dst_app_id>:<dst_app_entitlement_id>
     *
     * @generated from protobuf field: map<string, string> app_entitlement_proxy_bindings_error_map = 1
     */
    appEntitlementProxyBindingsErrorMap: {
        [key: string]: string;
    };
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AncestralBinding list = 2
     */
    list: AncestralBinding[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementProxySourcesRequest
 */
export interface ListAppEntitlementProxySourcesRequest {
    /**
     * @generated from protobuf field: string dst_app_id = 1
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 2
     */
    dstAppEntitlementId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementProxyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementProxyDestinationsRequest
 */
export interface ListAppEntitlementProxyDestinationsRequest {
    /**
     * @generated from protobuf field: string src_app_id = 1
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementProxyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementsProxyResponse
 */
export interface ListAppEntitlementsProxyResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementProxyView list = 1
     */
    list: AppEntitlementProxyView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementProxyBindingsRef
 */
export interface SearchAppEntitlementProxyBindingsRef {
    /**
     * @generated from protobuf field: string src_app_id = 1
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4
     */
    dstAppEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementProxyBindingsRequest
 */
export interface SearchAppEntitlementProxyBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 5
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 6
     */
    expandMask?: AppEntitlementProxyExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.ProxyBindingDirection directions = 7
     */
    directions: ProxyBindingDirection[];
    /**
     * If true, search will return the entitlements from the parent app as
     * implicit bindings.
     *
     * @generated from protobuf field: optional bool implicit = 8
     */
    implicit?: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementProxyBindingsResponse
 */
export interface SearchAppEntitlementProxyBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementProxyView list = 1
     */
    list: AppEntitlementProxyView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 4
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetChildEntitlementsRequest
 */
export interface GetChildEntitlementsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAncestorEntitlementsRequest
 */
export interface GetAncestorEntitlementsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.EntitlementChainResponse
 */
export interface EntitlementChainResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1
     */
    list: AppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementProxyResponse
 */
export interface DeleteAppEntitlementProxyResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.EnableAppEntitlementProxyRequest
 */
export interface EnableAppEntitlementProxyRequest {
    /**
     * @generated from protobuf field: string src_app_id = 1
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4
     */
    dstAppEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementProxyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.EnableAppEntitlementProxyResponse
 */
export interface EnableAppEntitlementProxyResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view = 1
     */
    appProxyEntitlementView?: AppEntitlementProxyView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.DisableAppEntitlementProxyRequest
 */
export interface DisableAppEntitlementProxyRequest {
    /**
     * @generated from protobuf field: string src_app_id = 1
     */
    srcAppId: string;
    /**
     * @generated from protobuf field: string src_app_entitlement_id = 2
     */
    srcAppEntitlementId: string;
    /**
     * @generated from protobuf field: string dst_app_id = 3
     */
    dstAppId: string;
    /**
     * @generated from protobuf field: string dst_app_entitlement_id = 4
     */
    dstAppEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementProxyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.DisableAppEntitlementProxyResponse
 */
export interface DisableAppEntitlementProxyResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view = 1
     */
    appProxyEntitlementView?: AppEntitlementProxyView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf enum c1.api.app.v1.ProxyBindingDirection
 */
export enum ProxyBindingDirection {
    /**
     * @generated from protobuf enum value: PROXY_BINDING_DIRECTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PROXY_BINDING_DIRECTION_INBOUND = 1;
     */
    INBOUND = 1,
    /**
     * @generated from protobuf enum value: PROXY_BINDING_DIRECTION_OUTBOUND = 2;
     */
    OUTBOUND = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementProxyRequest$Type extends MessageType<GetAppEntitlementProxyRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppEntitlementProxyRequest", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask }
        ]);
    }
    create(value?: PartialMessage<GetAppEntitlementProxyRequest>): GetAppEntitlementProxyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.srcAppId = "";
        message.srcAppEntitlementId = "";
        message.dstAppId = "";
        message.dstAppEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAppEntitlementProxyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppEntitlementProxyRequest): GetAppEntitlementProxyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string src_app_id */ 1:
                    message.srcAppId = reader.string();
                    break;
                case /* string src_app_entitlement_id */ 2:
                    message.srcAppEntitlementId = reader.string();
                    break;
                case /* string dst_app_id */ 3:
                    message.dstAppId = reader.string();
                    break;
                case /* string dst_app_entitlement_id */ 4:
                    message.dstAppEntitlementId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementProxyExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppEntitlementProxyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string src_app_id = 1; */
        if (message.srcAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.srcAppId);
        /* string src_app_entitlement_id = 2; */
        if (message.srcAppEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.srcAppEntitlementId);
        /* string dst_app_id = 3; */
        if (message.dstAppId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dstAppId);
        /* string dst_app_entitlement_id = 4; */
        if (message.dstAppEntitlementId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dstAppEntitlementId);
        /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementProxyExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppEntitlementProxyRequest
 */
export const GetAppEntitlementProxyRequest = new GetAppEntitlementProxyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementProxyResponse$Type extends MessageType<GetAppEntitlementProxyResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppEntitlementProxyResponse", [
            { no: 1, name: "app_proxy_entitlement_view", kind: "message", T: () => AppEntitlementProxyView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<GetAppEntitlementProxyResponse>): GetAppEntitlementProxyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<GetAppEntitlementProxyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppEntitlementProxyResponse): GetAppEntitlementProxyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view */ 1:
                    message.appProxyEntitlementView = AppEntitlementProxyView.internalBinaryRead(reader, reader.uint32(), options, message.appProxyEntitlementView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppEntitlementProxyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view = 1; */
        if (message.appProxyEntitlementView)
            AppEntitlementProxyView.internalBinaryWrite(message.appProxyEntitlementView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppEntitlementProxyResponse
 */
export const GetAppEntitlementProxyResponse = new GetAppEntitlementProxyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementProxy$Type extends MessageType<AppEntitlementProxy> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementProxy", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "system_builtin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "implicit", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "disabled_at", kind: "message", T: () => Timestamp }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App Entitlement Proxy Binding" } }] } });
    }
    create(value?: PartialMessage<AppEntitlementProxy>): AppEntitlementProxy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.srcAppId = "";
        message.srcAppEntitlementId = "";
        message.dstAppId = "";
        message.dstAppEntitlementId = "";
        message.systemBuiltin = false;
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementProxy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementProxy): AppEntitlementProxy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string src_app_id */ 1:
                    message.srcAppId = reader.string();
                    break;
                case /* string src_app_entitlement_id */ 2:
                    message.srcAppEntitlementId = reader.string();
                    break;
                case /* string dst_app_id */ 3:
                    message.dstAppId = reader.string();
                    break;
                case /* string dst_app_entitlement_id */ 4:
                    message.dstAppEntitlementId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 7:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* bool system_builtin */ 8:
                    message.systemBuiltin = reader.bool();
                    break;
                case /* optional bool implicit */ 9:
                    message.implicit = reader.bool();
                    break;
                case /* google.protobuf.Timestamp disabled_at */ 10:
                    message.disabledAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.disabledAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementProxy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string src_app_id = 1; */
        if (message.srcAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.srcAppId);
        /* string src_app_entitlement_id = 2; */
        if (message.srcAppEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.srcAppEntitlementId);
        /* string dst_app_id = 3; */
        if (message.dstAppId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dstAppId);
        /* string dst_app_entitlement_id = 4; */
        if (message.dstAppEntitlementId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dstAppEntitlementId);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 7; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool system_builtin = 8; */
        if (message.systemBuiltin !== false)
            writer.tag(8, WireType.Varint).bool(message.systemBuiltin);
        /* optional bool implicit = 9; */
        if (message.implicit !== undefined)
            writer.tag(9, WireType.Varint).bool(message.implicit);
        /* google.protobuf.Timestamp disabled_at = 10; */
        if (message.disabledAt)
            Timestamp.internalBinaryWrite(message.disabledAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementProxy
 */
export const AppEntitlementProxy = new AppEntitlementProxy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementProxyView$Type extends MessageType<AppEntitlementProxyView> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementProxyView", [
            { no: 1, name: "app_proxy_entitlement", kind: "message", T: () => AppEntitlementProxy },
            { no: 2, name: "src_app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "src_app_entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "dst_app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "dst_app_entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementProxyView>): AppEntitlementProxyView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.srcAppPath = "";
        message.srcAppEntitlementPath = "";
        message.dstAppPath = "";
        message.dstAppEntitlementPath = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementProxyView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementProxyView): AppEntitlementProxyView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementProxy app_proxy_entitlement */ 1:
                    message.appProxyEntitlement = AppEntitlementProxy.internalBinaryRead(reader, reader.uint32(), options, message.appProxyEntitlement);
                    break;
                case /* string src_app_path */ 2:
                    message.srcAppPath = reader.string();
                    break;
                case /* string src_app_entitlement_path */ 3:
                    message.srcAppEntitlementPath = reader.string();
                    break;
                case /* string dst_app_path */ 4:
                    message.dstAppPath = reader.string();
                    break;
                case /* string dst_app_entitlement_path */ 5:
                    message.dstAppEntitlementPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementProxyView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementProxy app_proxy_entitlement = 1; */
        if (message.appProxyEntitlement)
            AppEntitlementProxy.internalBinaryWrite(message.appProxyEntitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string src_app_path = 2; */
        if (message.srcAppPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.srcAppPath);
        /* string src_app_entitlement_path = 3; */
        if (message.srcAppEntitlementPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.srcAppEntitlementPath);
        /* string dst_app_path = 4; */
        if (message.dstAppPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dstAppPath);
        /* string dst_app_entitlement_path = 5; */
        if (message.dstAppEntitlementPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dstAppEntitlementPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementProxyView
 */
export const AppEntitlementProxyView = new AppEntitlementProxyView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementProxyExpandMask$Type extends MessageType<AppEntitlementProxyExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementProxyExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "src_app_id", "src_app_entitlement_id", "dst_app_id", "dst_app_entitlement_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementProxyExpandMask>): AppEntitlementProxyExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementProxyExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementProxyExpandMask): AppEntitlementProxyExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementProxyExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementProxyExpandMask
 */
export const AppEntitlementProxyExpandMask = new AppEntitlementProxyExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppEntitlementProxyRequest$Type extends MessageType<CreateAppEntitlementProxyRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAppEntitlementProxyRequest", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask }
        ]);
    }
    create(value?: PartialMessage<CreateAppEntitlementProxyRequest>): CreateAppEntitlementProxyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.srcAppId = "";
        message.srcAppEntitlementId = "";
        message.dstAppId = "";
        message.dstAppEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAppEntitlementProxyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAppEntitlementProxyRequest): CreateAppEntitlementProxyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string src_app_id */ 1:
                    message.srcAppId = reader.string();
                    break;
                case /* string src_app_entitlement_id */ 2:
                    message.srcAppEntitlementId = reader.string();
                    break;
                case /* string dst_app_id */ 3:
                    message.dstAppId = reader.string();
                    break;
                case /* string dst_app_entitlement_id */ 4:
                    message.dstAppEntitlementId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementProxyExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAppEntitlementProxyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string src_app_id = 1; */
        if (message.srcAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.srcAppId);
        /* string src_app_entitlement_id = 2; */
        if (message.srcAppEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.srcAppEntitlementId);
        /* string dst_app_id = 3; */
        if (message.dstAppId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dstAppId);
        /* string dst_app_entitlement_id = 4; */
        if (message.dstAppEntitlementId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dstAppEntitlementId);
        /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementProxyExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppEntitlementProxyRequest
 */
export const CreateAppEntitlementProxyRequest = new CreateAppEntitlementProxyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppEntitlementProxyResponse$Type extends MessageType<CreateAppEntitlementProxyResponse> {
    constructor() {
        super("c1.api.app.v1.CreateAppEntitlementProxyResponse", [
            { no: 1, name: "app_proxy_entitlement_view", kind: "message", T: () => AppEntitlementProxyView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<CreateAppEntitlementProxyResponse>): CreateAppEntitlementProxyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<CreateAppEntitlementProxyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAppEntitlementProxyResponse): CreateAppEntitlementProxyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view */ 1:
                    message.appProxyEntitlementView = AppEntitlementProxyView.internalBinaryRead(reader, reader.uint32(), options, message.appProxyEntitlementView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAppEntitlementProxyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view = 1; */
        if (message.appProxyEntitlementView)
            AppEntitlementProxyView.internalBinaryWrite(message.appProxyEntitlementView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppEntitlementProxyResponse
 */
export const CreateAppEntitlementProxyResponse = new CreateAppEntitlementProxyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementProxyRequest$Type extends MessageType<DeleteAppEntitlementProxyRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementProxyRequest", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteAppEntitlementProxyRequest>): DeleteAppEntitlementProxyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.srcAppId = "";
        message.srcAppEntitlementId = "";
        message.dstAppId = "";
        message.dstAppEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteAppEntitlementProxyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppEntitlementProxyRequest): DeleteAppEntitlementProxyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string src_app_id */ 1:
                    message.srcAppId = reader.string();
                    break;
                case /* string src_app_entitlement_id */ 2:
                    message.srcAppEntitlementId = reader.string();
                    break;
                case /* string dst_app_id */ 3:
                    message.dstAppId = reader.string();
                    break;
                case /* string dst_app_entitlement_id */ 4:
                    message.dstAppEntitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppEntitlementProxyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string src_app_id = 1; */
        if (message.srcAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.srcAppId);
        /* string src_app_entitlement_id = 2; */
        if (message.srcAppEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.srcAppEntitlementId);
        /* string dst_app_id = 3; */
        if (message.dstAppId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dstAppId);
        /* string dst_app_entitlement_id = 4; */
        if (message.dstAppEntitlementId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dstAppEntitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementProxyRequest
 */
export const DeleteAppEntitlementProxyRequest = new DeleteAppEntitlementProxyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementProxyWithCreateDestination$Type extends MessageType<AppEntitlementProxyWithCreateDestination> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementProxyWithCreateDestination", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementProxyWithCreateDestination>): AppEntitlementProxyWithCreateDestination {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.srcAppId = "";
        message.srcAppEntitlementId = "";
        message.dstAppId = "";
        message.dstResourceName = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementProxyWithCreateDestination>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementProxyWithCreateDestination): AppEntitlementProxyWithCreateDestination {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string src_app_id */ 1:
                    message.srcAppId = reader.string();
                    break;
                case /* string src_app_entitlement_id */ 2:
                    message.srcAppEntitlementId = reader.string();
                    break;
                case /* string dst_app_id */ 3:
                    message.dstAppId = reader.string();
                    break;
                case /* string dst_resource_name */ 4:
                    message.dstResourceName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementProxyWithCreateDestination, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string src_app_id = 1; */
        if (message.srcAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.srcAppId);
        /* string src_app_entitlement_id = 2; */
        if (message.srcAppEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.srcAppEntitlementId);
        /* string dst_app_id = 3; */
        if (message.dstAppId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dstAppId);
        /* string dst_resource_name = 4; */
        if (message.dstResourceName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dstResourceName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementProxyWithCreateDestination
 */
export const AppEntitlementProxyWithCreateDestination = new AppEntitlementProxyWithCreateDestination$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BindingWithNewOrExisting$Type extends MessageType<BindingWithNewOrExisting> {
    constructor() {
        super("c1.api.app.v1.BindingWithNewOrExisting", [
            { no: 1, name: "app_proxy_entitlement", kind: "message", oneof: "binding", T: () => AppEntitlementProxy },
            { no: 2, name: "app_proxy_entitlement_create", kind: "message", oneof: "binding", T: () => AppEntitlementProxyWithCreateDestination }
        ]);
    }
    create(value?: PartialMessage<BindingWithNewOrExisting>): BindingWithNewOrExisting {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.binding = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<BindingWithNewOrExisting>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BindingWithNewOrExisting): BindingWithNewOrExisting {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementProxy app_proxy_entitlement */ 1:
                    message.binding = {
                        oneofKind: "appProxyEntitlement",
                        appProxyEntitlement: AppEntitlementProxy.internalBinaryRead(reader, reader.uint32(), options, (message.binding as any).appProxyEntitlement)
                    };
                    break;
                case /* c1.api.app.v1.AppEntitlementProxyWithCreateDestination app_proxy_entitlement_create */ 2:
                    message.binding = {
                        oneofKind: "appProxyEntitlementCreate",
                        appProxyEntitlementCreate: AppEntitlementProxyWithCreateDestination.internalBinaryRead(reader, reader.uint32(), options, (message.binding as any).appProxyEntitlementCreate)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BindingWithNewOrExisting, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementProxy app_proxy_entitlement = 1; */
        if (message.binding.oneofKind === "appProxyEntitlement")
            AppEntitlementProxy.internalBinaryWrite(message.binding.appProxyEntitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementProxyWithCreateDestination app_proxy_entitlement_create = 2; */
        if (message.binding.oneofKind === "appProxyEntitlementCreate")
            AppEntitlementProxyWithCreateDestination.internalBinaryWrite(message.binding.appProxyEntitlementCreate, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.BindingWithNewOrExisting
 */
export const BindingWithNewOrExisting = new BindingWithNewOrExisting$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkCreateAppEntitlementProxyWithDestinationsRequest$Type extends MessageType<BulkCreateAppEntitlementProxyWithDestinationsRequest> {
    constructor() {
        super("c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsRequest", [
            { no: 1, name: "bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BindingWithNewOrExisting, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "300" } } } }
        ]);
    }
    create(value?: PartialMessage<BulkCreateAppEntitlementProxyWithDestinationsRequest>): BulkCreateAppEntitlementProxyWithDestinationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bindings = [];
        if (value !== undefined)
            reflectionMergePartial<BulkCreateAppEntitlementProxyWithDestinationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkCreateAppEntitlementProxyWithDestinationsRequest): BulkCreateAppEntitlementProxyWithDestinationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.BindingWithNewOrExisting bindings */ 1:
                    message.bindings.push(BindingWithNewOrExisting.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkCreateAppEntitlementProxyWithDestinationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.BindingWithNewOrExisting bindings = 1; */
        for (let i = 0; i < message.bindings.length; i++)
            BindingWithNewOrExisting.internalBinaryWrite(message.bindings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsRequest
 */
export const BulkCreateAppEntitlementProxyWithDestinationsRequest = new BulkCreateAppEntitlementProxyWithDestinationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkCreateAppEntitlementProxyWithDestinationsResponse$Type extends MessageType<BulkCreateAppEntitlementProxyWithDestinationsResponse> {
    constructor() {
        super("c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsResponse", [
            { no: 1, name: "app_entitlement_proxy_bindings_error_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 2, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AncestralBinding },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<BulkCreateAppEntitlementProxyWithDestinationsResponse>): BulkCreateAppEntitlementProxyWithDestinationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appEntitlementProxyBindingsErrorMap = {};
        message.list = [];
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<BulkCreateAppEntitlementProxyWithDestinationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkCreateAppEntitlementProxyWithDestinationsResponse): BulkCreateAppEntitlementProxyWithDestinationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, string> app_entitlement_proxy_bindings_error_map */ 1:
                    this.binaryReadMap1(message.appEntitlementProxyBindingsErrorMap, reader, options);
                    break;
                case /* repeated c1.api.app.v1.AncestralBinding list */ 2:
                    message.list.push(AncestralBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: BulkCreateAppEntitlementProxyWithDestinationsResponse["appEntitlementProxyBindingsErrorMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof BulkCreateAppEntitlementProxyWithDestinationsResponse["appEntitlementProxyBindingsErrorMap"] | undefined, val: BulkCreateAppEntitlementProxyWithDestinationsResponse["appEntitlementProxyBindingsErrorMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsResponse.app_entitlement_proxy_bindings_error_map");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: BulkCreateAppEntitlementProxyWithDestinationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, string> app_entitlement_proxy_bindings_error_map = 1; */
        for (let k of globalThis.Object.keys(message.appEntitlementProxyBindingsErrorMap))
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.appEntitlementProxyBindingsErrorMap[k]).join();
        /* repeated c1.api.app.v1.AncestralBinding list = 2; */
        for (let i = 0; i < message.list.length; i++)
            AncestralBinding.internalBinaryWrite(message.list[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.BulkCreateAppEntitlementProxyWithDestinationsResponse
 */
export const BulkCreateAppEntitlementProxyWithDestinationsResponse = new BulkCreateAppEntitlementProxyWithDestinationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementProxySourcesRequest$Type extends MessageType<ListAppEntitlementProxySourcesRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementProxySourcesRequest", [
            { no: 1, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementProxySourcesRequest>): ListAppEntitlementProxySourcesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.dstAppId = "";
        message.dstAppEntitlementId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementProxySourcesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementProxySourcesRequest): ListAppEntitlementProxySourcesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string dst_app_id */ 1:
                    message.dstAppId = reader.string();
                    break;
                case /* string dst_app_entitlement_id */ 2:
                    message.dstAppEntitlementId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementProxyExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementProxySourcesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string dst_app_id = 1; */
        if (message.dstAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.dstAppId);
        /* string dst_app_entitlement_id = 2; */
        if (message.dstAppEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.dstAppEntitlementId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementProxyExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementProxySourcesRequest
 */
export const ListAppEntitlementProxySourcesRequest = new ListAppEntitlementProxySourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementProxyDestinationsRequest$Type extends MessageType<ListAppEntitlementProxyDestinationsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementProxyDestinationsRequest", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementProxyDestinationsRequest>): ListAppEntitlementProxyDestinationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.srcAppId = "";
        message.srcAppEntitlementId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementProxyDestinationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementProxyDestinationsRequest): ListAppEntitlementProxyDestinationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string src_app_id */ 1:
                    message.srcAppId = reader.string();
                    break;
                case /* string src_app_entitlement_id */ 2:
                    message.srcAppEntitlementId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementProxyExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementProxyDestinationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string src_app_id = 1; */
        if (message.srcAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.srcAppId);
        /* string src_app_entitlement_id = 2; */
        if (message.srcAppEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.srcAppEntitlementId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementProxyExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementProxyDestinationsRequest
 */
export const ListAppEntitlementProxyDestinationsRequest = new ListAppEntitlementProxyDestinationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementsProxyResponse$Type extends MessageType<ListAppEntitlementsProxyResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementsProxyResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementProxyView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementsProxyResponse>): ListAppEntitlementsProxyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementsProxyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementsProxyResponse): ListAppEntitlementsProxyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementProxyView list */ 1:
                    message.list.push(AppEntitlementProxyView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementsProxyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementProxyView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementProxyView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementsProxyResponse
 */
export const ListAppEntitlementsProxyResponse = new ListAppEntitlementsProxyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementProxyBindingsRef$Type extends MessageType<SearchAppEntitlementProxyBindingsRef> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementProxyBindingsRef", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementProxyBindingsRef>): SearchAppEntitlementProxyBindingsRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.srcAppId = "";
        message.srcAppEntitlementId = "";
        message.dstAppId = "";
        message.dstAppEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementProxyBindingsRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementProxyBindingsRef): SearchAppEntitlementProxyBindingsRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string src_app_id */ 1:
                    message.srcAppId = reader.string();
                    break;
                case /* string src_app_entitlement_id */ 2:
                    message.srcAppEntitlementId = reader.string();
                    break;
                case /* string dst_app_id */ 3:
                    message.dstAppId = reader.string();
                    break;
                case /* string dst_app_entitlement_id */ 4:
                    message.dstAppEntitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementProxyBindingsRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string src_app_id = 1; */
        if (message.srcAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.srcAppId);
        /* string src_app_entitlement_id = 2; */
        if (message.srcAppEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.srcAppEntitlementId);
        /* string dst_app_id = 3; */
        if (message.dstAppId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dstAppId);
        /* string dst_app_entitlement_id = 4; */
        if (message.dstAppEntitlementId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dstAppEntitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementProxyBindingsRef
 */
export const SearchAppEntitlementProxyBindingsRef = new SearchAppEntitlementProxyBindingsRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementProxyBindingsRequest$Type extends MessageType<SearchAppEntitlementProxyBindingsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementProxyBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask },
            { no: 7, name: "directions", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.ProxyBindingDirection", ProxyBindingDirection, "PROXY_BINDING_DIRECTION_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 8, name: "implicit", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementProxyBindingsRequest>): SearchAppEntitlementProxyBindingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.appId = "";
        message.appEntitlementId = "";
        message.directions = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementProxyBindingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementProxyBindingsRequest): SearchAppEntitlementProxyBindingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 5:
                    message.appEntitlementId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask */ 6:
                    message.expandMask = AppEntitlementProxyExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.app.v1.ProxyBindingDirection directions */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.directions.push(reader.int32());
                    else
                        message.directions.push(reader.int32());
                    break;
                case /* optional bool implicit */ 8:
                    message.implicit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementProxyBindingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 5; */
        if (message.appEntitlementId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appEntitlementId);
        /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 6; */
        if (message.expandMask)
            AppEntitlementProxyExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.ProxyBindingDirection directions = 7; */
        if (message.directions.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.directions.length; i++)
                writer.int32(message.directions[i]);
            writer.join();
        }
        /* optional bool implicit = 8; */
        if (message.implicit !== undefined)
            writer.tag(8, WireType.Varint).bool(message.implicit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementProxyBindingsRequest
 */
export const SearchAppEntitlementProxyBindingsRequest = new SearchAppEntitlementProxyBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementProxyBindingsResponse$Type extends MessageType<SearchAppEntitlementProxyBindingsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementProxyBindingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementProxyView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementProxyBindingsResponse>): SearchAppEntitlementProxyBindingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementProxyBindingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementProxyBindingsResponse): SearchAppEntitlementProxyBindingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementProxyView list */ 1:
                    message.list.push(AppEntitlementProxyView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                case /* c1.api.search.v1.Facets facets */ 4:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementProxyBindingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementProxyView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementProxyView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        /* c1.api.search.v1.Facets facets = 4; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementProxyBindingsResponse
 */
export const SearchAppEntitlementProxyBindingsResponse = new SearchAppEntitlementProxyBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetChildEntitlementsRequest$Type extends MessageType<GetChildEntitlementsRequest> {
    constructor() {
        super("c1.api.app.v1.GetChildEntitlementsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<GetChildEntitlementsRequest>): GetChildEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<GetChildEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetChildEntitlementsRequest): GetChildEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 3:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetChildEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetChildEntitlementsRequest
 */
export const GetChildEntitlementsRequest = new GetChildEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAncestorEntitlementsRequest$Type extends MessageType<GetAncestorEntitlementsRequest> {
    constructor() {
        super("c1.api.app.v1.GetAncestorEntitlementsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<GetAncestorEntitlementsRequest>): GetAncestorEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAncestorEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAncestorEntitlementsRequest): GetAncestorEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 3:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAncestorEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAncestorEntitlementsRequest
 */
export const GetAncestorEntitlementsRequest = new GetAncestorEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementChainResponse$Type extends MessageType<EntitlementChainResponse> {
    constructor() {
        super("c1.api.app.v1.EntitlementChainResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<EntitlementChainResponse>): EntitlementChainResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<EntitlementChainResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntitlementChainResponse): EntitlementChainResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementView list */ 1:
                    message.list.push(AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EntitlementChainResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EntitlementChainResponse
 */
export const EntitlementChainResponse = new EntitlementChainResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementProxyResponse$Type extends MessageType<DeleteAppEntitlementProxyResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementProxyResponse", []);
    }
    create(value?: PartialMessage<DeleteAppEntitlementProxyResponse>): DeleteAppEntitlementProxyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAppEntitlementProxyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppEntitlementProxyResponse): DeleteAppEntitlementProxyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppEntitlementProxyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementProxyResponse
 */
export const DeleteAppEntitlementProxyResponse = new DeleteAppEntitlementProxyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableAppEntitlementProxyRequest$Type extends MessageType<EnableAppEntitlementProxyRequest> {
    constructor() {
        super("c1.api.app.v1.EnableAppEntitlementProxyRequest", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask }
        ]);
    }
    create(value?: PartialMessage<EnableAppEntitlementProxyRequest>): EnableAppEntitlementProxyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.srcAppId = "";
        message.srcAppEntitlementId = "";
        message.dstAppId = "";
        message.dstAppEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<EnableAppEntitlementProxyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnableAppEntitlementProxyRequest): EnableAppEntitlementProxyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string src_app_id */ 1:
                    message.srcAppId = reader.string();
                    break;
                case /* string src_app_entitlement_id */ 2:
                    message.srcAppEntitlementId = reader.string();
                    break;
                case /* string dst_app_id */ 3:
                    message.dstAppId = reader.string();
                    break;
                case /* string dst_app_entitlement_id */ 4:
                    message.dstAppEntitlementId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementProxyExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnableAppEntitlementProxyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string src_app_id = 1; */
        if (message.srcAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.srcAppId);
        /* string src_app_entitlement_id = 2; */
        if (message.srcAppEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.srcAppEntitlementId);
        /* string dst_app_id = 3; */
        if (message.dstAppId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dstAppId);
        /* string dst_app_entitlement_id = 4; */
        if (message.dstAppEntitlementId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dstAppEntitlementId);
        /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementProxyExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EnableAppEntitlementProxyRequest
 */
export const EnableAppEntitlementProxyRequest = new EnableAppEntitlementProxyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableAppEntitlementProxyResponse$Type extends MessageType<EnableAppEntitlementProxyResponse> {
    constructor() {
        super("c1.api.app.v1.EnableAppEntitlementProxyResponse", [
            { no: 1, name: "app_proxy_entitlement_view", kind: "message", T: () => AppEntitlementProxyView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<EnableAppEntitlementProxyResponse>): EnableAppEntitlementProxyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<EnableAppEntitlementProxyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnableAppEntitlementProxyResponse): EnableAppEntitlementProxyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view */ 1:
                    message.appProxyEntitlementView = AppEntitlementProxyView.internalBinaryRead(reader, reader.uint32(), options, message.appProxyEntitlementView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnableAppEntitlementProxyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view = 1; */
        if (message.appProxyEntitlementView)
            AppEntitlementProxyView.internalBinaryWrite(message.appProxyEntitlementView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EnableAppEntitlementProxyResponse
 */
export const EnableAppEntitlementProxyResponse = new EnableAppEntitlementProxyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisableAppEntitlementProxyRequest$Type extends MessageType<DisableAppEntitlementProxyRequest> {
    constructor() {
        super("c1.api.app.v1.DisableAppEntitlementProxyRequest", [
            { no: 1, name: "src_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "src_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "dst_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "dst_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementProxyExpandMask }
        ]);
    }
    create(value?: PartialMessage<DisableAppEntitlementProxyRequest>): DisableAppEntitlementProxyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.srcAppId = "";
        message.srcAppEntitlementId = "";
        message.dstAppId = "";
        message.dstAppEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<DisableAppEntitlementProxyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DisableAppEntitlementProxyRequest): DisableAppEntitlementProxyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string src_app_id */ 1:
                    message.srcAppId = reader.string();
                    break;
                case /* string src_app_entitlement_id */ 2:
                    message.srcAppEntitlementId = reader.string();
                    break;
                case /* string dst_app_id */ 3:
                    message.dstAppId = reader.string();
                    break;
                case /* string dst_app_entitlement_id */ 4:
                    message.dstAppEntitlementId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementProxyExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DisableAppEntitlementProxyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string src_app_id = 1; */
        if (message.srcAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.srcAppId);
        /* string src_app_entitlement_id = 2; */
        if (message.srcAppEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.srcAppEntitlementId);
        /* string dst_app_id = 3; */
        if (message.dstAppId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dstAppId);
        /* string dst_app_entitlement_id = 4; */
        if (message.dstAppEntitlementId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dstAppEntitlementId);
        /* c1.api.app.v1.AppEntitlementProxyExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementProxyExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DisableAppEntitlementProxyRequest
 */
export const DisableAppEntitlementProxyRequest = new DisableAppEntitlementProxyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DisableAppEntitlementProxyResponse$Type extends MessageType<DisableAppEntitlementProxyResponse> {
    constructor() {
        super("c1.api.app.v1.DisableAppEntitlementProxyResponse", [
            { no: 1, name: "app_proxy_entitlement_view", kind: "message", T: () => AppEntitlementProxyView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<DisableAppEntitlementProxyResponse>): DisableAppEntitlementProxyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<DisableAppEntitlementProxyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DisableAppEntitlementProxyResponse): DisableAppEntitlementProxyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view */ 1:
                    message.appProxyEntitlementView = AppEntitlementProxyView.internalBinaryRead(reader, reader.uint32(), options, message.appProxyEntitlementView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DisableAppEntitlementProxyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementProxyView app_proxy_entitlement_view = 1; */
        if (message.appProxyEntitlementView)
            AppEntitlementProxyView.internalBinaryWrite(message.appProxyEntitlementView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DisableAppEntitlementProxyResponse
 */
export const DisableAppEntitlementProxyResponse = new DisableAppEntitlementProxyResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppEntitlementsProxy
 */
export const AppEntitlementsProxy = new ServiceType("c1.api.app.v1.AppEntitlementsProxy", [
    { name: "ListSources", options: { "authz.method": { role: "VIEWER" } }, I: ListAppEntitlementProxySourcesRequest, O: ListAppEntitlementsProxyResponse },
    { name: "ListDestinations", options: { "authz.method": { role: "VIEWER" } }, I: ListAppEntitlementProxyDestinationsRequest, O: ListAppEntitlementsProxyResponse },
    { name: "BulkCreateAppEntitlementProxyWithDestinations", options: { "authz.method": { role: "EDITOR" } }, I: BulkCreateAppEntitlementProxyWithDestinationsRequest, O: BulkCreateAppEntitlementProxyWithDestinationsResponse },
    { name: "Create", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{src_app_id}/{src_app_entitlement_id}/bindings/{dst_app_id}/{dst_app_entitlement_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App Entitlement Proxy Binding" }], group: "App Entitlement Proxy Binding" }] }, "authz.method": { role: "EDITOR" } }, I: CreateAppEntitlementProxyRequest, O: CreateAppEntitlementProxyResponse },
    { name: "Delete", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{src_app_id}/{src_app_entitlement_id}/bindings/{dst_app_id}/{dst_app_entitlement_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App Entitlement Proxy Binding" }], group: "App Entitlement Proxy Binding" }] }, "authz.method": { role: "EDITOR" } }, I: DeleteAppEntitlementProxyRequest, O: DeleteAppEntitlementProxyResponse },
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{src_app_id}/{src_app_entitlement_id}/bindings/{dst_app_id}/{dst_app_entitlement_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App Entitlement Proxy Binding" }], group: "App Entitlement Proxy Binding" }] }, "authz.method": { role: "VIEWER" } }, I: GetAppEntitlementProxyRequest, O: GetAppEntitlementProxyResponse },
    { name: "Enable", options: { "authz.method": { role: "EDITOR" } }, I: EnableAppEntitlementProxyRequest, O: EnableAppEntitlementProxyResponse },
    { name: "Disable", options: { "authz.method": { role: "EDITOR" } }, I: DisableAppEntitlementProxyRequest, O: DisableAppEntitlementProxyResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppEntitlementsProxySearch
 */
export const AppEntitlementsProxySearch = new ServiceType("c1.api.app.v1.AppEntitlementsProxySearch", [
    { name: "SearchAppEntitlementProxyBindings", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementProxyBindingsRequest, O: SearchAppEntitlementProxyBindingsResponse },
    { name: "GetChildEntitlements", options: { "authz.method": { role: "VIEWER" } }, I: GetChildEntitlementsRequest, O: EntitlementChainResponse },
    { name: "GetAncestorEntitlements", options: { "authz.method": { role: "VIEWER" } }, I: GetAncestorEntitlementsRequest, O: EntitlementChainResponse }
]);
